import { get, put, post, del } from '@/libs/api.request'
import { collectId } from '@/libs/util'
import { getChangeLogs as getPCBChanges } from '@/api/pcb'
import {
  getMechanicalPart,
  createMechanicalPart,
  updateMechanicalPart,
  getAssembledPart,
  createAssembledPart,
  updateAssembledPart,
  getElectronicPart,
  createElectronicPart,
  updateElectronicPart,
  getElectronicPartSpec,
  updateElectronicPartSpec,
  getMechanicalPartSpec,
  updateMechanicalPartSpec,
  getElectronicPartChanges,
  getMechanicalPartChanges,
  getAssembledPartChanges } from '@/api/part'

export default {
  state: {
    partVariations: {},
    parts: [],
    specMetadatas: [],
    partCategoriesTree: [],
    partCategories: {},
    partCategoriesIds: []
  },
  getters: {
    getVariationsByPartId: (state) => (id) => {
      return state.partVariations[id]
    },
    partSpecMetadatas: (state) => {
      return state.specMetadatas
    }
  },
  mutations: {
    setPartVariations(state, partVariations) {
      state.partVariations = _.assign({}, state.partVariations, partVariations)
    },
    setParts(state, parts) {
      state.parts = parts
    },
    setPartSpecMetadatas(state, metadatas) {
      state.specMetadatas = metadatas
    },
    setPartCategoriesTree(state, partCategories) {
      state.partCategoriesTree = partCategories
    },
    setPartCategoriesDetail(state, category) {
      if (category) {
        state.partCategories[category.id] = category
      }
    },
    setPartCategoriesIds(state, partCategoriesIds) {
      state.partCategoriesIds = partCategoriesIds
    }
  },
  actions: {
    // Manufacturer part
    getPart ({ commit }, id) {
      return get(`parts/${id}`).then(res => {
        return res.data
      })
    },
    getPartSpecMetadatas ({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        if (state.parts.specMetadatas &&
          !_.isEmpty(state.parts.specMetadatas) &&
          (!data || !data.reload)) {
          resolve(state.parts.specMetadatas)
        } else {
          get('parts/spec-metadata').then(res => {
            commit('setPartSpecMetadatas', res.data)
            resolve(res.data)
          }).catch(error => {
            reject(error)
          })
        }
      })
    },
    /** @deprecated */
    updatePart ({ commit }, data) {
      return put(`parts/${data.id}`, data).then(res => {
        return res.data
      })
    },
    getElectronicPartSpec ({ commit }, id) {
      return getElectronicPartSpec(id).then(res => {
        return res.data
      })
    },
    updateElectronicPartSpec ({ commit }, { id, data }) {
      return updateElectronicPartSpec(id, data).then(res => {
        return res.data
      })
    },
    getMechanicalPartSpec ({ commit }, id) {
      return getMechanicalPartSpec(id).then(res => {
        return res.data
      })
    },
    updateMechanicalPartSpec ({ commit }, { id, data }) {
      return updateMechanicalPartSpec(id, data).then(res => {
        return res.data
      })
    },
    updatePartSpecs ({ commit }, data) {
      return put(`parts/${data.id}/specs`, data).then(res => {
        return res.data
      })
    },
    createPart ({ commit }, data) {
      return post(`parts/create`, data).then(res => {
        return res.data
      })
    },
    // electronic part
    getElectronicPart ({ commit }, id) {
      return getElectronicPart(id).then(res => {
        return res.data
      })
    },
    updateElectronicPart ({ commit }, { id, data }) {
      return updateElectronicPart(id, data).then(res => {
        return res.data
      })
    },
    createElectronicPart ({ commit }, data) {
      return createElectronicPart(data).then(res => {
        return res.data
      })
    },
    getManufacturerPartChangeLog ({ commit }, { component_type, id }) {
      component_type = component_type.replace('-', '_')
      switch (component_type) {
        case 'electronic_part':
          return getElectronicPartChanges(id)
        case 'mechanical_part':
          return getMechanicalPartChanges(id)
        case 'assembled_part':
          return getAssembledPartChanges(id)
        case 'circuit_board':
          return getPCBChanges(id)
      }
    },

    // Part :: assoated part number
    generatePartNumber ({ commit }, data) {
      let partId = data['manufacturer_part_id']
      return post(`parts/${partId}/generate-part-number`).then(res => {
        return res.data
      })
    },
    changePartNumber ({ commit }, data) {
      let partId = data['manufacturer_part_id']
      return put(`parts/${partId}/change-part-number`, data).then(res => {
        return res.data
      })
    },
    createPartNumber ({ commit }, data) {
      let partId = data['manufacturer_part_id']
      return post(`parts/${partId}/generate-part-number`, data).then(res => {
        return res.data
      })
    },
    getPartNumberChanges ({ commit }) {
      return get(`parts/part-number-changes`).then(res => {
        return res.data
      })
    },
    removePartNumber ({ commit }, partId) {
      return del(`parts/${partId}/remove-part-number`).then(res => {
        return res.data
      })
    },
    // Part categories
    getPartCategoryTree ({ commit, state }, component_type) {
      return new Promise((resolve, reject) => {
        if (state.parts.partCategoriesTree &&
          !_.isEmpty(state.parts.partCategoriesTree)) {
          resolve(state.parts.partCategoriesTree)
        } else {
          get(`parts/${component_type}/categories`).then(res => {
            commit('setPartCategoriesTree', res.data)
            if (res.data.length > 0) {
              let categoriesIdArray = []
              collectId(res.data, categoriesIdArray)
              commit('setPartCategoriesIds', categoriesIdArray)
            }
            resolve(res.data)
          }).catch(error => {
            reject(error)
          })
        }
      })
    },
    // Part categories
    getPartCategory ({ commit, state }, id) {
      return new Promise((resolve, reject) => {
        if (state.parts.partCategories &&
          _.get(state.parts.partCategories, id)
        ) {
          resolve(_.get(state.parts.partCategories, id))
        } else {
          get(`parts/categories/${id}`).then(res => {
            commit('setPartCategoriesDetail', res.data)
            resolve(res.data)
          }).catch(error => {
            reject(error)
          })
        }
      })
    },
    getPartCategoryById ({ commit }, id) {
      return get(`parts/categories/${id}`).then(res => {
        return res.data
      })
    },

    // Octopart component search
    searchOctopartComponent ({ commit }, data) {
      return get('parts/octopart/search', data).then(res => {
        return res.data
      })
    },
    // Octopart component transfer to pangu component
    transferOctopartComponent ({ commit }, octopartComponents) {
      return post('parts/octopart/transfer', {
        components: octopartComponents
      }).then(res => {
        return res.data
      })
    },

    /** @todo: Needs to be reviewed all below */

    // getPart ({ commit }, id) {
    //   return get(`part/part/${id}`)
    // },
    getPartMigrateHistory ({ commit }, id) {
      return get(`part/part/migrate-history/${id}`)
    },
    // mechanical part
    getMechanicalPart ({ commit }, id) {
      return getMechanicalPart(id).then(resp => {
        return resp
      })
    },
    createMechanicalPart ({ commit }, data) {
      return createMechanicalPart(data).then(resp => {
        return resp
      })
    },
    updateMechanicalPart ({ commit }, { id, data }) {
      return updateMechanicalPart(id, data).then(resp => {
        return resp
      })
    },
    // assembled part
    getAssembledPart ({ commit }, id) {
      return getAssembledPart(id).then(resp => {
        return resp
      })
    },
    createAssembledPart ({ commit }, data) {
      return createAssembledPart(data).then(resp => {
        return resp
      })
    },
    updateAssembledPart ({ commit }, { id, data }) {
      return updateAssembledPart(id, data).then(resp => {
        return resp
      })
    }
  }
}
